module.exports = __webpack_public_path__ + "img/HQ-PS24-V2_V20.8f2ee629.jpg";